var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._b({staticClass:"close-btn",attrs:{"type":"button","aria-label":_vm.$attrs['aria-label'] || 'Close'},on:{"click":function($event){return _vm.$emit('click')}}},'button',_vm.$attrs,false),[_c('close-icon',{attrs:{"size":24,"aria-hidden":"true"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }